import { createFileRoute } from '@tanstack/react-router';

import {
  loadSimulationMessages,
  loadSimulationPayrollHubScreen,
  simulationPublicPayrollScreen,
} from '@/modules/simulation/route';
import { lazyScreen } from '@/shared/screen/lazy-screen';

// Consignado público no caminho do legado com o rótulo padrão (`router.tsx:1195-1207`, só com
// `ENABLE_NEW_SIMULATION === 1`): a flag e a permissão vão no manifesto. Arquivo leve (JS inicial).
export const Route = createFileRoute('/_app/ccb/contratar/consignado-publico/')({
  staticData: { screen: simulationPublicPayrollScreen },
  loader: () => loadSimulationMessages(),
  component: lazyScreen(loadSimulationPayrollHubScreen, 'PublicPayrollHubRouteScreen'),
});
